var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.869,7.795C20.869,7.795,20.5,6,20,6c-0.375,0-1.871,1.684-2.599,2.528C17.141,8.83,16.766,9,16.368,9 C15.612,9,15,8.388,15,7.632c0-0.398,0.17-0.773,0.472-1.033C16.316,5.871,18,4.375,18,4c0-0.5-1.799-0.878-1.799-0.878 C15.809,3.041,15.404,3,15,3c-3.309,0-6,2.717-6,6.056c0,0.42,0.051,0.845,0.153,1.285l-6.214,6.103 c-1.252,1.269-1.252,3.332,0.001,4.601C3.55,21.66,4.363,22,5.231,22c0.867,0,1.681-0.34,2.28-0.946l6.229-6.12 C14.169,15,14.587,15,15,15c3.364,0,6-2.611,6-5.944C21,8.634,20.956,8.209,20.869,7.795z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.b5aec7e02cfaf530e8ccb8c0a2ea4e81.svg";
export { ForwardRef as ReactComponent };